/** Passos do onboarding (`.steps`). `current` começa em 0. */
export function Stepper({ steps, current }: { steps: string[]; current: number }) {
  return (
    <ol className="steps" style={{ listStyle: 'none', padding: '0', marginBottom: '0' }}>
      {steps.map((s, i) => (
        <li key={s} className={`step${i === current ? ' on' : ''}`} aria-current={i === current ? 'step' : undefined}>
          <i>{i + 1}</i>
          {s}
        </li>
      ))}
    </ol>
  );
}
